export default (...args) => p =>
  args.length > 1
    ? p.theme.typography.fontFamily[args[0]][args[1]]
    : p.theme.typography.fontFamily[args[0]]
